import type { KeywordDefinition, SchemaValidateFunction } from 'ajv';
import { FormPageInputData, SingleSelectionProperty } from 'shared';
import { SingleSelectionValueForValidation } from '../../shared';

const KEYWORD = 'drillDown';

const validate: SchemaValidateFunction = (
  schema: SingleSelectionProperty['drillDown'],
  data: SingleSelectionValueForValidation,
  _,
  dataCxt,
) => {
  if (!schema || data.value == null) {
    return true;
  }

  const { parentId, invalidValuePairErrorMessage, valuePairs } = schema;
  const parentInputItem = (dataCxt?.parentData as FormPageInputData)[parentId];

  if (!('value' in parentInputItem) || parentInputItem.value == null) {
    return true;
  }

  const valuePair = valuePairs.find(
    ({ parentValue }) => parentValue === parentInputItem.value,
  );

  if (valuePair?.childValues.includes(data.value)) {
    return true;
  }

  validate.errors = [
    {
      keyword: KEYWORD,
      params: { keyword: KEYWORD },
      message: invalidValuePairErrorMessage,
    },
  ];

  return false;
};

export const drillDown: KeywordDefinition = {
  keyword: KEYWORD,
  type: 'object',
  validate,
};
